"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var PrismCss_1 = __importDefault(require("./PrismCss"));
var reconnect_js_1 = require("reconnect.js");
reconnect_js_1.getNewOutlet('CodeEditorModal', null, {
  autoDelete: false
});
function CodeEditorModal(props) {
  var _a = reconnect_js_1.useOutlet('CodeEditorModal'),
    modalInfo = _a[0],
    setModalInfo = _a[1];
  var updateValue = (modalInfo || {}).updateValue;
  var modalContentRef = react_1.default.useRef();
  var textEditorRef = react_1.default.useRef();
  var _b = react_1.default.useState(true),
    highlight = _b[0],
    setHighlight = _b[1];
  react_1.default.useEffect(function () {
    if (modalInfo === null) {
      setHighlight(true);
    }
  }, [modalInfo]);
  return react_1.default.createElement(antd_1.Modal, {
    visible: !!modalInfo,
    onCancel: function onCancel() {
      return setModalInfo(null);
    },
    destroyOnClose: true,
    bodyStyle: {
      padding: 0
    },
    style: {
      padding: 0
    },
    width: "80%",
    footer: null
  }, react_1.default.createElement("div", {
    style: {
      padding: 20
    }
  }, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, react_1.default.createElement("h3", null, "Edit ", modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.lang.toUpperCase()), react_1.default.createElement("div", {
    style: {
      alignSelf: 'flex-end',
      display: 'flex',
      alignItems: 'center'
    }
  }, react_1.default.createElement("input", {
    id: "rev-hl-syntax",
    type: "checkbox",
    checked: highlight,
    onChange: function onChange(e) {
      if (window.confirm('尚未儲存的資料將會丟失, 確定要繼續嗎?')) {
        setHighlight(e.target.checked);
      }
    }
  }), react_1.default.createElement("label", {
    htmlFor: "rev-hl-syntax",
    style: {
      marginLeft: 8
    }
  }, "Syntax highlight"))), highlight ? react_1.default.createElement(ModalContent, __assign({}, modalInfo, {
    ref: modalContentRef
  })) : react_1.default.createElement(TextEditor, __assign({}, modalInfo, {
    ref: textEditorRef
  })), react_1.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, react_1.default.createElement(antd_1.Button, {
    onClick: function onClick() {
      var nextValue = highlight ? modalContentRef.current.getValue() : textEditorRef.current.getValue();
      updateValue(nextValue);
      antd_1.message.success('已修改');
    }
  }, "\u78BA\u8A8D\u4FEE\u6539"))));
}
exports.default = CodeEditorModal;
function TextEditorImpl(props, ref) {
  var initialValue = props.value;
  var textareaElemRef = react_1.default.useRef(null);
  var _a = react_1.default.useState(initialValue),
    value = _a[0],
    setValue = _a[1];
  ref.current = {
    getValue: function getValue() {
      return value;
    }
  };
  return react_1.default.createElement("div", {
    style: {
      height: 500,
      width: '100%',
      padding: '10px 0',
      display: 'flex',
      marginBottom: 20
    }
  }, react_1.default.createElement("textarea", {
    style: {
      border: '1px solid #ccc',
      flex: 1,
      alignSelf: 'stretch',
      padding: 10
    },
    ref: textareaElemRef,
    spellCheck: false,
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    }
  }));
}
var TextEditor = react_1.default.forwardRef(TextEditorImpl);
function ModalContentImpl(props, ref) {
  var _a = props.lang,
    lang = _a === void 0 ? 'javascript' : _a,
    initialValue = props.value;
  var textareaElemRef = react_1.default.useRef(null);
  var highlightElemRef = react_1.default.useRef(null);
  var codeElemRef = react_1.default.useRef(null);
  var _b = react_1.default.useState(initialValue),
    value = _b[0],
    setValue = _b[1];
  ref.current = {
    getValue: function getValue() {
      return value;
    }
  };
  var syncContent = react_1.default.useCallback(function (nextValue) {
    if (!codeElemRef.current || !textareaElemRef.current || !highlightElemRef.current) {
      return;
    }
    var Prism = window.Prism;
    if (!Prism) {
      return;
    }
    setValue(nextValue);
    var html = Prism.highlight(nextValue, Prism.languages[lang], lang);
    codeElemRef.current.innerHTML = html;
  }, [lang]);
  react_1.default.useEffect(function () {
    syncContent(initialValue);
  }, [initialValue, syncContent]);
  var syncScroll = react_1.default.useCallback(function () {
    if (!codeElemRef.current || !textareaElemRef.current || !highlightElemRef.current) {
      return;
    }
    highlightElemRef.current.scrollTop = textareaElemRef.current.scrollTop;
    highlightElemRef.current.scrollLeft = textareaElemRef.current.scrollLeft;
  }, []);
  react_1.default.useEffect(function () {
    syncScroll();
  });
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement("textarea", {
    id: "editing",
    ref: textareaElemRef,
    spellCheck: false,
    value: value,
    onInput: syncScroll,
    onScroll: syncScroll,
    onChange: function onChange(e) {
      return syncContent(e.target.value);
    }
  }), react_1.default.createElement("pre", {
    id: "highlighting",
    "aria-hidden": true,
    ref: highlightElemRef
  }, react_1.default.createElement("code", {
    className: "language-" + lang,
    ref: codeElemRef
  })));
}
var ModalContent = react_1.default.forwardRef(ModalContentImpl);
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  position: relative;\n  height: 500px;\n\n  #editing,\n  #highlighting {\n    /* Both elements need the same text and space styling so they are directly on top of each other */\n    position: absolute;\n    margin: 10px 0;\n    top: 0;\n    left: 0;\n    padding: 10px;\n    border: 1px solid #ccc;\n    width: 100%;\n    height: 450px;\n    background-color: white;\n  }\n\n  #editing,\n  #highlighting,\n  #highlighting * {\n    /* Also add text styles to highlighting tokens */\n    font-size: 12px;\n    font-family: monospace;\n    line-height: 16px;\n  }\n\n  #editing {\n    z-index: 1;\n  }\n\n  #highlighting {\n    z-index: 0;\n  }\n\n  #editing {\n    color: transparent;\n    background: transparent;\n    caret-color: blue; /* Or choose your favorite color */\n  }\n\n  /* Can be scrolled */\n  #editing,\n  #highlighting {\n    overflow: auto;\n    white-space: nowrap; /* Allows textarea to scroll horizontally */\n  }\n"], ["\n  ", "\n\n  position: relative;\n  height: 500px;\n\n  #editing,\n  #highlighting {\n    /* Both elements need the same text and space styling so they are directly on top of each other */\n    position: absolute;\n    margin: 10px 0;\n    top: 0;\n    left: 0;\n    padding: 10px;\n    border: 1px solid #ccc;\n    width: 100%;\n    height: 450px;\n    background-color: white;\n  }\n\n  #editing,\n  #highlighting,\n  #highlighting * {\n    /* Also add text styles to highlighting tokens */\n    font-size: 12px;\n    font-family: monospace;\n    line-height: 16px;\n  }\n\n  #editing {\n    z-index: 1;\n  }\n\n  #highlighting {\n    z-index: 0;\n  }\n\n  #editing {\n    color: transparent;\n    background: transparent;\n    caret-color: blue; /* Or choose your favorite color */\n  }\n\n  /* Can be scrolled */\n  #editing,\n  #highlighting {\n    overflow: auto;\n    white-space: nowrap; /* Allows textarea to scroll horizontally */\n  }\n"])), PrismCss_1.default);
var templateObject_1;